export default {
  devices: {
    deviceRemoved: 'دستگاه حذف شد',
    deviceUpdated: 'دستگاه به روز رسانی شد',
    deviceAdded: 'دستگاه افزوده شد',
    devices: 'دستگاه ها',
    device: 'دستگاه',
    deviceOwner: 'مالک دستگاه',
    refreshRate: 'نرخ به روزرسانی',
    deviceCode: 'کد دستگاه',
    warningConfig: 'تنظیمات هشدار',
    emergencyCallAlarm: 'هشدار تماس اضطراری',
    fallingAlarm: 'هشدار سقوط',
    heartPulseAlarm: 'هشدار Heart pulse',
    heartRateAlarm: 'هشدار Heart rate',
    pulseRateAlarm: 'هشدار Pulse rate',
    spo2Alarm: 'هشدار Spo2',
    temperatureAlarm: 'هشدار دما'
  }
}
